import React from 'react';

interface SearchIconProps {
  isActive?: boolean;
  isRelative?: boolean;
  className?: string;
}

export const SearchIcon: React.FC<SearchIconProps> = ({ isActive, isRelative, className }) => {
  return (
    <i
      className={`icon ${isActive ? 'icon-map' : ''} ${isRelative ? 'relative' : ''} ${className || ''}`}
    />
  );
};

